import { render, staticRenderFns } from "./pruebaJuego.vue?vue&type=template&id=566554f7"
import script from "./pruebaJuego.vue?vue&type=script&lang=js"
export * from "./pruebaJuego.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports